export const checkForSelection = (callBack: (a: any) => void, spanLink?: any) => {
  if (window.getSelection().rangeCount) {
    callBack(spanLink || null)
  }
}
